/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-is-mounted */
import { loggerInstance, buildLogMessage, removeSensitiveInfo } from './utils';

const LOG_LEVELS = {
  INFO: 'info',
  ERROR: 'error',
};

/**
 * Make an api call to argus service to log given message with additional options
 */
class LoggerApi {
  static async logApi(params) {
    const {
      level,
      module,
      message = '',
      data,
      path = '',
      funcName = '',
      line = '',
      stacktrace = '',
    } = params;

    const logMessage = buildLogMessage({ module, message, data });

    try {
      const requestBody = {
        level_name: level,
        timestamp: Math.floor(Date.now() / 1000),
        message: logMessage,
        extra: {
          location: {
            file_path: path,
            function_name: funcName,
            line_number: line,
          },
        },
        stacktrace,
      };

      await loggerInstance.post('/logs/', requestBody);
    } catch (err) {
      console.log('Failed to log the message to argus service!');
      console.error(err);
      console.log({ ...err });
    }
  }

  static logger({ level, module, message, data, path, funcName, line, stacktrace }) {
    // make disableLoggerInLocal flag to false to connect to your local argus server
    const disableLoggerInLocal = true;
    if (disableLoggerInLocal && process.env.REACT_APP_NODE_ENV === 'local') {
      console.log(buildLogMessage({ message, module, data }));
    } else {
      this.logApi({ level, module, message, data, path, funcName, line, stacktrace });
    }
  }

  static info({ module, message, data, path, funcName, line }) {
    const fileOptions = { path, funcName, line };
    const messageOptions = { module, message, data };
    this.logger({ level: LOG_LEVELS.INFO, ...messageOptions, ...fileOptions });
  }

  static error({ module, message, data, path, funcName, line, stacktrace }) {
    const fileOptions = { path, funcName, line };
    data = this.sanitizeSensitiveData(data);
    const messageOptions = { module, message, data };
    this.logger({ level: LOG_LEVELS.ERROR, ...messageOptions, ...fileOptions, stacktrace });
  }

  static sanitizeSensitiveData(input) {
    let parsed = input;
    let isInputString = false;

    if (typeof input === 'string') {
      isInputString = true;
      try {
        parsed = JSON.parse(input);
      } catch {
        return input;
      }
    }

    if (parsed && typeof parsed === 'object') {
      removeSensitiveInfo(parsed);
    }
    return isInputString ? JSON.stringify(parsed) : parsed;
  }
}

export default LoggerApi;
